import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import de from 'locales/de.json';
import en from 'locales/en.json';
import es from 'locales/es.json';
import fr from 'locales/fr.json';
import it from 'locales/it.json';
import pt from 'locales/pt.json';
import zh_hk from 'locales/zh-HK.json';
import zh_sg from 'locales/zh-SG.json';

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

i18n.use(initReactI18next).init({
  // debug: true,
  fallbackLng: 'en',
  ns: ['dashboard'],
  defaultNS: 'dashboard',
  nsSeparator: '.',
  returnNull: false,
  lng: 'en',
  resources: {
    de,
    en,
    es,
    fr,
    it,
    pt,
    'zh': zh_sg,
    'zh-HK': zh_hk,
    'zh-SG': zh_sg,
  },
});

export const supportedLanguages = ['de', 'es', 'en', 'fr', 'it', 'pt', 'zh', 'zh-HK', 'zh-SG'];

export const isSupportedLanguage = (lang: string) => supportedLanguages.includes(lang);

const sanitizeLanguage = (lang: string) => {
  const separatorIndex = lang.indexOf('-');
  if (separatorIndex >= 0) {
    return lang.substring(0, separatorIndex).toLowerCase() + lang.substring(separatorIndex).toUpperCase();
  }
  return lang.toLowerCase();
}

export const setLanguage = (lang: string) => {
  const sanitizedLanguage = sanitizeLanguage(lang);
  if (isSupportedLanguage(sanitizedLanguage)) {
    i18n.changeLanguage(sanitizedLanguage);
  }
};

export { i18n };
